import { render, staticRenderFns } from "./EwalletEntry.vue?vue&type=template&id=ea08f4ea"
import script from "./EwalletEntry.vue?vue&type=script&lang=js"
export * from "./EwalletEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports